import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  "page-index": "",
  class: /*#__PURE__*/_normalizeClass([
    'w-full h-full',
    'flex justify-center',
    'bg-white',
    'p-2 pt-16'
  ])
}
const _hoisted_2 = {
  class: /*#__PURE__*/_normalizeClass([
      'w-2/3 md:w-full'
    ])
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_BasicText = _resolveComponent("BasicText")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.payload, (institution, index) => {
          return (_openBlock(), _createElementBlock("li", { key: index }, [
            _createVNode(_component_router_link, {
              to: { name: 'Institution', params: {id: institution.id} },
              class: _normalizeClass([
            'flex md:flex-wrap'
          ])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_BasicText, {
                  text: (index + 1).toString(),
                  size: 'sm',
                  class: _normalizeClass([
              'w-10 md:w-1/12'
            ])
                }, null, 8, ["text"]),
                _createVNode(_component_BasicText, {
                  text: `${institution.name}`,
                  size: 'sm',
                  class: _normalizeClass([
              'w-64 md:w-11/12',
            ])
                }, null, 8, ["text"]),
                _createVNode(_component_BasicText, {
                  text: `${institution.allocation.physical[0].lat}, ${institution.allocation.physical[0].lng}`,
                  size: 'sm',
                  class: _normalizeClass([
              'ml-10',
              'grow',
              'text-right',
              'md:hidden'
            ])
                }, null, 8, ["text"])
              ]),
              _: 2
            }, 1032, ["to"])
          ]))
        }), 128))
      ])
    ])
  ]))
}